<template>
  <div>
    <el-form label-width="90" inline size="mini">
      <el-form-item label="签约客户">
        <el-select clearable filterable v-model="query.agentid" placeholder="请选择签约客户">
          <el-option v-for="item in agentData" :value="item.id" :key="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="登记人员">
        <el-select clearable v-model="query.ctuid" placeholder="请选择登记人员">
          <el-option v-for="item in userData" :value="item.id" :key="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="资质类型">
        <el-select clearable filterable v-model="query.qtypeid" placeholder="请选择资质类型">
          <el-option v-for="item in qtData" :value="item.id" :key="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="签约日期">
        <el-date-picker
          v-model="query.sigdate"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="有效日期">
        <el-date-picker
          v-model="query.vdate"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="登记日期">
        <el-date-picker
          v-model="query.ctdate"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="ue_searchSign" icon="el-icon-search">查询</el-button>
        <el-button type="primary" @click="ue_AddSign" icon="el-icon-plus">增加</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="signData" stripe
              :row-style="f_showStyle"
              :height="tb_height"
              border size="mini">
      <el-table-column label="编号" prop="signid"  show-overflow-tooltip width="60"></el-table-column>
      <el-table-column label="操作" width="80" >
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" @click="ue_EditSign(scope.row)"
                     size="mini" type="text" title="编辑">编辑
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="二维码下载" width="200">
        <template slot-scope="scope">
          <bar-code :ref="'barcode_'+scope.$index" height="200px" width="200px"
                    :content="SourceHost+'query.html?id='+scope.row.signid"></bar-code>
        </template>
      </el-table-column>
      <el-table-column label="资质类型" :formatter="f_format" prop="qtypeid" width="150"
                       show-overflow-tooltip></el-table-column>
      <el-table-column label="客户名称" :formatter="f_format" prop="agentid" width="180"
                       show-overflow-tooltip></el-table-column>
      <el-table-column label="授权区域"  prop="area" width="120"
                       show-overflow-tooltip></el-table-column>
      <el-table-column label="授权编号"  prop="pryid" width="100"
                       show-overflow-tooltip></el-table-column>
      <el-table-column label="签约时间" :formatter="f_format" prop="sigdate" width="120"></el-table-column>
      <el-table-column label="有效期" :formatter="f_format" prop="vdate" width="120"></el-table-column>
      <el-table-column label="登记日期" :formatter="f_format" prop="ctdate" width="120"></el-table-column>
      <el-table-column label="创建人员" :formatter="f_format" prop="ctuid" width="120"></el-table-column>
      <el-table-column label="所属公司" :formatter="f_format" prop="companyid"
                       show-overflow-tooltip></el-table-column>
    </el-table>

    <el-col :span="24" class="toolbar" style="position: absolute; bottom: 35px; z-index: 100; margin: 0;">
      <el-pagination layout="total,sizes,prev, pager, next,jumper, ->"
                     @current-change="ue_page_CurrentChange"
                     @size-change="ue_page_SizeChange"
                     :page-size="pageSize" :total="total" style="float:left;">
      </el-pagination>
    </el-col>

    <el-dialog title="签约登记"
               class="d-dialog"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               :visible.sync="showEdit"
               width="400px">

      <el-form label-width="80px"
               size="mini"
               ref="Edit"
               :rules="rules"
               :model="Edit">
        <el-form-item label="编号">
          <el-input v-model="Edit.signid" :disabled="true" placeholder="自动生成"></el-input>
        </el-form-item>
        <el-form-item label="签约客户" prop="agentid">
          <el-select clearable
                     filterable
                     v-model="Edit.agentid"
                     placeholder="请选择签约客户">
            <el-option v-for="item in agentData" :value="item.id" :key="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="授权区域" prop="area">
          <el-input v-model="Edit.area"   placeholder="请输入授权区域"></el-input>
        </el-form-item>
        <el-form-item label="授权编号" prop="pryid">
          <el-input v-model="Edit.pryid"   placeholder="请输入授权编号"></el-input>
        </el-form-item>

        <el-form-item label="资质类型" prop="qtypeid">
          <el-select clearable
                     filterable
                     v-model="Edit.qtypeid"
                     placeholder="请选择资质类型">
            <el-option v-for="item in qtData" :value="item.id" :key="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="签约日期" prop="sigdate">
          <el-date-picker
            v-model="Edit.sigdate"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="签约年限">
          <el-input-number v-model="Edit.year"></el-input-number>
        </el-form-item>
        <el-form-item label="有效期" prop="vdate">
          <el-date-picker
            v-model="Edit.vdate"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="showEdit = false">关闭</el-button>
        <el-button size="mini" type="primary" @click.native="ue_saveSign">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

  import * as Api from '../api/api'
  import Utils from '../api/Utils'
  import BarCode from "./BarCode.vue";

  export default {
    components: {BarCode},
    data() {
      return {
        user: JSON.parse(sessionStorage.getItem("user")),
        agentData: [],
        userData: [],
        qtData: [],
        signData: [],
        companyData: [],
        query: {},
        page: 1,
        pageSize: 10,
        total: 0,
        SourceHost: Api.SourceHost,
        showEdit: false,
        Edit: {},
        tb_height:'400px',
        rules: {
          agentid: [
            {required: true, message: '请选择签约客户', trigger: 'blur'}
          ],
          area: [
            {required: true, message: '请输入授权区域', trigger: 'blur'}
          ],
          pryid: [
            {required: true, message: '请输入授权编号', trigger: 'blur'}
          ],
          qtypeid: [
            {required: true, message: '请选择资质类型', trigger: 'blur'}
          ],
          sigdate: [
            {required: true, message: '请选择签约日期', trigger: 'blur'}
          ],
          vdate: [
            {required: true, message: '请选择有效日期', trigger: 'blur'}
          ]
        },
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      }
    },
    mounted() {
      this.f_GetAgent();
      this.f_GetSign();
      window.onresize=()=>{
        this.f_AutoHeight();
      }
    },
    methods: {
      ue_searchSign() {
        this.page=1;
        this.f_GetSign();
      },
      ue_AddSign() {
        this.showEdit = true;
        this.Edit = {
          signid:"",
          year: 1,
          sigdate: "",
          vdate: "",
          agentid: "",
          qtypeid: "",
          ctuid: this.user.id,
          ctdate: Utils.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss"),
          companyid: this.user.companyid
        };
      },
      ue_EditSign(row) {
        this.showEdit = true;
        this.Edit = JSON.parse(JSON.stringify(row));
      },
      ue_saveSign() {
        this.$refs.Edit.validate((valid) => {
          if (valid) {
            let parm = JSON.parse(JSON.stringify(this.Edit));
            parm.vdate = Utils.formatDate(new Date(this.Edit.vdate));
            parm.sigdate = Utils.formatDate(new Date(this.Edit.sigdate));
            Api.AddSign(parm).then(res => {
              if (res.code === 1) {
                this.showEdit = false;
                this.f_GetSign();
              } else {
                this.$alert(`保存失败:${res.error}`, "提示信息",{type:'error'});
              }
            });
          }
        });
      },
      ue_page_CurrentChange(page) {
        this.page = page;
        this.f_GetSign();
      },
      ue_page_SizeChange(size) {
        this.pageSize = size;
        this.f_GetSign();
      },
      f_GetSign() {
        let parm = {
          page: this.page,
          pageSize: this.pageSize
        };
        for (let key in this.query) {
          if (key.endsWith("date")) {
            if (this.query[key] && this.query[key].length > 0) {
              parm[`s${key}`] = Utils.formatDate(this.query[key][0], "yyyy-MM-dd 00:00:00");
              parm[`e${key}`] = Utils.formatDate(this.query[key][1], "yyyy-MM-dd 23:59:59");
            }
          } else if (this.query[key] && this.query[key] != "") {
            parm[key] = this.query[key];
          }
        }

        Api.GetSign(parm, this.user.companyid).then(res => {
          if (res.code === 1) {
            this.signData=[];
            this.signData = res.data;
            this.total = res.total;
            setTimeout(()=>{
              this.signData.forEach((o,index)=>{
                this.$refs['barcode_'+index].createBarCode();
              });

              this.f_AutoHeight();
            },500);
          }
        });
      },
      f_GetAgent() {
        Api.GetAgent({}, this.user.companyid).then(res => {
          if (res.code === 1) {
            this.agentData = res.data;
          }
          this.f_GetUser();
          this.f_GetQutype();
          this.f_GetCompany();
        })
      },
      f_GetUser() {
        Api.GetUser({}, this.user.companyid).then(res => {
          if (res.code === 1)
            this.userData = res.data;
        });
      },
      f_GetCompany() {
        Api.GetCompany({}).then(res => {
          if (res.code === 1)
            this.companyData = res.data;
        })
      },
      f_GetQutype() {
        Api.GetQutype({}, this.user.companyid).then(res => {
          if (res.code === 1)
            this.qtData = res.data;
        });
      },
      f_format(row, column, cellValue) {
        let col = column.property;
        let result = cellValue;
        if (col === "companyid") {
          let dd = this.companyData.find(it => it.id == cellValue);
          if (dd) result = dd.name;
        }
        if (col === "ctuid") {
          let dd = this.userData.find(it => it.id == cellValue);
          if (dd) result = dd.name;
        }
        if (col === "qtypeid") {
          let dd = this.qtData.find(it => it.id == cellValue);
          if (dd) result = dd.name;
        }
        if (col === "agentid") {
          let dd = this.agentData.find(it => it.id == cellValue);
          if (dd) result = dd.name;
        }
        if (col.endsWith("date") && cellValue != "") {
          result = Utils.formatDate(new Date(cellValue), "yyyy-MM-dd");
        }
        return result;
      },
      f_showStyle({row, rowIndex}) {
        if (row.vdate) {
          let vdate = new Date(row.vdate);
          if (vdate < (new Date())) {
            return "color:red;";
          }
        }
      },
      f_AutoHeight () {
        //初始化界面计算明细表格高度
        let gd = document.getElementsByClassName('el-table')[0];
        let bb = document.getElementsByClassName('toolbar')[0];
        let gh = Utils.GetElHeight(gd, bb);
        this.tb_height = '' + parseInt(gh)+'px'
      }
    },
    watch: {
      'Edit.year'(nv, ov) {
        if (nv !== ov) {
          let date = this.Edit.sigdate;
          if (date && date !== "") this.Edit.vdate = Utils.DateAdd("y", nv, new Date(date));
        }
      },
      'Edit.sigdate'(nv, ov) {
        if (nv && nv !== ov) {
          let year = this.Edit.year;
          if (year) this.Edit.vdate = Utils.DateAdd("y", year, new Date(nv));
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sign.vue